import { detectResources } from '@opentelemetry/resources';
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import {
  BatchSpanProcessor,
  ConsoleSpanExporter,
} from '@opentelemetry/sdk-trace-base';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { trace } from '@opentelemetry/api';
import { resourceFromAttributes } from '@opentelemetry/resources';
export const initTracing = async () => {
  // ✅ Detect default environment & process resource

  const resource = resourceFromAttributes({
    [SemanticResourceAttributes.SERVICE_NAME]: 'oneflow-frontend',
  });

  const exporter = new OTLPTraceExporter({
    url: 'https://oneflowstaging.app.protoexpress.com/otel/v1/traces',
  });
  console.log('[Tracing] Resource:', resource);
  console.log('[Tracing] Attributes:', (resource as any).attributes);
  const provider = new WebTracerProvider({
    resource: resource,
    spanProcessors: [new BatchSpanProcessor(exporter)],
  });

  provider.register({
    propagator: new W3CTraceContextPropagator(),
  });

  const tracer = trace.getTracer('oneflow-frontend');

  window.addEventListener('beforeunload', () => {
    provider.forceFlush();
  });

  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation(),
      new XMLHttpRequestInstrumentation(),
    ],
  });

  console.log('[Tracing] Initialized with service.name = oneflow-frontend');
};

export const getTracer = () => {
  return trace.getTracer('oneflow-frontend');
};
